export const createFrameTickerWorker = (fps: number): Worker => {
  const intervalMs = Math.round(1000 / fps);
  const blob = new Blob([`setInterval(() => postMessage(0), ${intervalMs})`], {
    type: "application/javascript",
  });
  const blobUrl = URL.createObjectURL(blob);
  const worker = new Worker(blobUrl);
  URL.revokeObjectURL(blobUrl);
  return worker;
};
